import i18n from '@/plugins/i18n';
import * as moment from 'moment';
import { UserActionLogInfo } from './user-action-log-info';

export class UserActionLogInfoGroup {
    public mode: string = 'span';
    public html: boolean = true;
    public date!: moment.Moment;
    public userEmail: string = '';
    public children: UserActionLogInfo[] = [];

    public get label(): string {
        return `<em>${i18n.t('common.labels.date')}:</em> <span style='color: darkblue;'>${moment.utc(this.date).local().format('LL')}</span> | <em>${i18n.t('common.labels.userEmail')}:</em> <span style='color: darkblue;'>${this.userEmail}</span>`;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, {
            children: json.children ? json.children.map((c: any) => new UserActionLogInfo(c)) : [],
        });
    }
}
